import { MERGE_ENTITIES } from 'redux/modules/entities/actions/types';

export const mergeEntities = entities => ({
  type: MERGE_ENTITIES,
  entities,
});
